import { useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import { GNoValidation } from '../../../config/Validate';
import { defaultPageRowOptions, defaultRowOptions, SkeletonbodyTemplate, Skeletonitems } from '../../../appconfig/Settings';
import { postAllData } from '../../../service/ProductService';
import { DOWNLOADGOVENMENTREPORT, DOWNLOADREGISTRATIONVALIDATION, GOVERNMENTREP } from '../../../config/ApiConstant';
import { GovernmentReportListColumns } from '../../../appconfig/DatatableSetting';
import { combinedFullNameTemplate, dateTemplate } from '../../../appconfig/DatatableTemplateSetting';
import { InputText } from 'primereact/inputtext';
import { downloadData, exportData } from '../../../appconfig/AppHelper';
import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';

export const GovernmentReport = () => {
    document.title = 'Government Report | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [errors, setErrors] = useState<any>({});
    const [governmentReportList, setGovernmentReportList] = useState<any>([]);
    const [regDetails, setRegDetails] = useState<any>({});
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const [exportLoader, setExportLoader] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [showButton, setShowButton] = useState<boolean>(false);

    const handleChange = (e: any, name: string) => {
        let val = (e.target && e.target.value) || e.value || '';

        setRegDetails({ ...regDetails, [name]: val });
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <div>
                    <div className="input-effect-div">
                        <InputText value={regDetails?.year} name="year" autoComplete="off" placeholder="Enter Year" onChange={(e) => handleChange(e, 'year')} className={errors['year'] && 'p-invalid'} />
                        <span className="focus-bg"></span>
                    </div>

                    <small className="p-invalid-txt">{errors['year']}</small>
                </div>

                <Button label="Show" onClick={() => getGovernmentReport()} loading={showLoading} className="ml-3"></Button>
            </>
        );
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button icon="pi pi-file-export" label="Export" onClick={() => exportCSV()} className="p-button-success" loading={exportLoader} disabled={showButton ? false : true}></Button>
                <Button icon="pi pi-download" label="Download" onClick={() => downloadAllData()} className="mx-2" loading={loading} disabled={showButton ? false : true}></Button>
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAllFilter()} className="p-button-outlined ml-2"></Button>
            </>
        );
    };

    //downloadDAta
    const downloadAllData = async () => {
        try {
            setLoading(true);

            // Request Data
            const requestData = {
                year: regDetails?.year
            };

            const response = await downloadData(DOWNLOADGOVENMENTREPORT, 'Government_Report', requestData);
            if (response === true) {
                setLoading(false);
            } else if (response === false) {
                setLoading(false);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    //export CSv
    const exportCSV = async () => {
        setExportLoader(true);

        let res = await exportData('Government_Report');
        if (res === true) {
            setExportLoader(false);
        } else {
            setExportLoader(false);
        }
    };

    //Clear All Filter
    const clearAllFilter = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    // getGovernmentReportList
    const getGovernmentReport = async () => {
        try {
            const { errors, isError } = GNoValidation(regDetails?.year);
            setErrors(errors);
            if (!isError) {
                setPageLoad(false);
                setShowLoading(true);

                // Request Data
                const requestData = {
                    year: regDetails?.year
                };

                const response = await postAllData(GOVERNMENTREP, requestData);

                if (response) {
                    setPageLoad(true);
                    setShowLoading(false);
                    setGovernmentReportList(response?.data);
                    setShowButton(true);
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setPageLoad(true);
                setShowButton(false);
                setShowLoading(false);

                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    return (
        <>
            <AppBreadcrumb currentMenu={'Reports'} pageName={'Government Report'} pageTitle={'Government Report'} goToPage={true} />

            <Toast ref={toast} />
            <div className="grid crud-demo mt-2">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={governmentReportList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Data Found"
                                    removableSort
                                >
                                    {GovernmentReportListColumns.map((col: any, i: any) => {
                                        if (col.field === 'BOD' || col.field === 'LastVDate') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} style={{ minWidth: '8rem' }} />;
                                        } else if (col.field === 'app_name') {
                                            return <Column key={col.field} header={col.header} body={combinedFullNameTemplate} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        } else if (col.field === 'sr_no') {
                                            return <Column key={col.field} header={col.header} body={(_, { rowIndex }) => rowIndex + 1} style={{ minWidth: '4rem' }} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {GovernmentReportListColumns.map((col: any, i: any) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
